export default __webpack_public_path__ + "0bb9e2ac68ddbefe6c7826ac97edf289.png";